const company =  function() {

//    $(document).on('loadFinish', function() {
//        (new MessageFader('.tabMessages li').process($('.tabBtnSave')));
//    });

    $(document).on('change', '.companyWriteDocument', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataElement = $(e.currentTarget).find(":selected");
        var target = '/write_stddok.php?did=' + dataElement.data('actionId') + '&fid=' + $('#dataId').val();

        if (dataElement.data('actionType') === 'draft') {
            target = '/write_stddok.php?draftid=' + dataElement.data('actionId');
        }

        Esearcher.Helper.navigation.redirect(dataElement.data('backUrl'), target);
    });

    $(document).on('click', '.companyWriteEmailButton', function (e) {
        e.preventDefault();
        e.stopPropagation();
        Esearcher.Helper.navigation.redirect($(e.currentTarget).data('backUrl'),
            '/write_stddok.php?did=0&fid=' + $('#dataId').val());
    });

    $(document).on('click', '.companyRemoveAssignmentButton', function () {
        $('#companyFormMotherCompanyId').val(0);
        $('#companyFormMotherCompanyStr').val('');
    });
};

export default company;
